import { Button } from "@mui/material";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import Editor from "../../../Editor/Editor";
import { AxiosRequest } from "../../../Url";
import { smetaModals } from "../../Tools/modalManager";
import CheckBoxWithLabel from "./Components/CheckBoxWithLabel";
import { getColumnsGenNums, getDefaultFieldsGenNums } from "./Components/simpleLoacalGrid/simpleLocalGridColumns";
import styles from "./Components/styles.module.css";
import DialogSimpleLocalTable from "./DialogSimpleLocalTable";

const getGroupParams = (data: { module: string; groupID: string }) => {
  const params = new Map([
    ["prefix", data.module],
    ["comand", "GetGroupParams"],
    ["GroupID", data.groupID],
  ]);
  return AxiosRequest(true, params);
};

const setGroupParams = (data: {
  module: string;
  groupID: string;
  code: string;
  format: string;
  name: string;
  preview: string;
}) => {
  const params = new Map([
    ["prefix", data.module],
    ["comand", "SetGroupParams"],
    ["GroupID", data.groupID],
    ["Code", data.code],
    ["Format", data.format],
    ["GenName", data.name],
    ["Preview", data.preview],
  ]);
  return AxiosRequest(true, params);
};

interface Props {
  props: { Buttons: string; Module: string; GroupID: string };
  smetaModalId?: string;
}

interface Data {
  Code: string;
  Format: string;
  Name: string;
  GenName: { items: Array<any> };
  Preview: string;
}

interface Result {
  code: string;
  format: string;
  name: string;
  preview: string;
}

interface EditData {
  value: string;
}

interface CheckEditData {
  CheckState: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function DialogTreeParams({ props, smetaModalId }: Props) {
  const [data, setData] = useState<Data>();

  const [code, setCode] = useState("");
  const [format, setFormat] = useState("");
  const [name, setName] = useState("");
  const [preview, setPreview] = useState("0");

  const result = useRef<Result>({
    code: "",
    format: "",
    name: "",
    preview: "0",
  });

  const { Buttons: buttons } = props;

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    setCode(data?.Code || "");
    setFormat(data?.Format || "");
    setName(data?.Name || "");
    setPreview(data?.Preview || "0");
    result.current = {
      code: data?.Code || "",
      format: data?.Format || "",
      name: data?.Name || "",
      preview: data?.Preview || "0",
    };
  }, [data]);

  const loadData = async () => {
    setData(
      await getGroupParams({
        module: props.Module,
        groupID: props.GroupID,
      }),
    );
  };

  const onEditCode = async (editData: EditData) => {
    setCode(editData.value);
    result.current.code = editData.value;
  };
  const onEditFormat = async (editData: EditData) => {
    setFormat(editData.value);
    result.current.format = editData.value;
  };
  const onEditName = async (editData: EditData) => {
    setName(editData.value);
    result.current.name = editData.value;
  };

  const onEditNameButtonClick = async () => {
    smetaModals.open(
      <DialogSimpleLocalTable
        props={{
          Buttons: 2,
          records: data?.GenName?.items || [],
          columns: getColumnsGenNums(),
          defaultFields: getDefaultFieldsGenNums(),
          keyField: "CODE",
          recordKeys: ["OrgTypeCls", "OrgName", "Value"],
          rights: "2",
          setData: changeData,
        }}
      />,
      { hiddenButton: true, Title: "Параметры группы" },
    );
  };

  const changeData = (newRecords: Array<any>) => {
    if (data?.GenName) {
      data.GenName.items = newRecords;
      setData({ ...data });
    }
  };

  const onCheckPreview = async (editData: CheckEditData) => {
    setPreview(editData.CheckState);
    result.current.preview = editData.CheckState;
  };

  const onSelect = async () => {
    setGroupParams({ module: props.Module, groupID: props.GroupID, ...result.current });
    smetaModals.close(smetaModalId);
  };

  return (
    <div className={clsx(styles.mainDialogBlock)}>
      <div className={clsx(styles.fullDialogFlexContainer, styles.dialogTreeParamsMainBlock)}>
        <div className={clsx(styles.dialogTreeParamsTitle)}>Основные средства</div>
        <div className={clsx(styles.dialogTreeParamsItem)}>
          <div className={clsx(styles.dialogTreeParamsLabel)}>Код группы: </div>
          <div className={clsx(styles.dialogTreeParamsEditorDiv)}>
            <Editor onEdit={onEditCode} value={code} editMask={data?.Mask} />
          </div>
        </div>
        <div className={clsx(styles.dialogTreeParamsItem)}>
          <div className={clsx(styles.dialogTreeParamsLabel)}>Формат инв. номера: </div>
          <div className={clsx(styles.dialogTreeParamsEditorDiv)}>
            <Editor onEdit={onEditFormat} value={format} />
          </div>
        </div>
        <div className={clsx(styles.dialogTreeParamsItem)}>
          <div className={clsx(styles.dialogTreeParamsLabel)}>Генератор номера: </div>
          <div className={clsx(styles.dialogTreeParamsEditorDiv)}>
            <Editor onEditButtonClick={onEditNameButtonClick} onEdit={onEditName} value={name} editStyle={16} />
          </div>
        </div>
        <div className={clsx(styles.dialogTreeParamsItem)}>
          <CheckBoxWithLabel
            onEdit={onCheckPreview}
            label="Использовать для представления объектов из других групп"
            CheckState={preview}
          />
        </div>
      </div>
      <div className={clsx(styles.dialogButtonsContainer)}>
        <Button
          onClick={onSelect}
          size="small"
          variant="outlined"
          className={clsx(
            styles.dialogButton,
            "button_Modal_Select",
            buttons && (Number(buttons) & 1) === 0 && "hidden",
          )}
          value="1"
        >
          Установить
        </Button>

        <Button
          size="small"
          variant="outlined"
          value="2"
          className={clsx(styles.dialogButton, "button_Modal_Close")}
          onClick={() => {
            smetaModals.close(smetaModalId);
          }}
        >
          Закрыть
        </Button>
      </div>
    </div>
  );
}
